import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import { withRouter } from "react-router-dom"
import { debounce } from "debounce"
import { PDFDownloadLink } from "@react-pdf/renderer"
import dayjs from "dayjs"
import PYPDownloadPage from "../PYPDownloadPage/PYPDownloadPage"
import CommitButtonWithoutClickState from "../CommitButtonWithoutClickState/CommitButtonWithoutClickState"
import colors from "../../Constants/colors"
import { ADDITIONAL_COURSE_ID } from "../../Constants/courses"
import Actions from "../../Redux/Actions"

const moment = dayjs
const styles = {
  redButton: {
    width: "100%",
    transition: "all 0.3s ease-in-out",
    backgroundColor: "inherit",
    color: colors.white,
    height: "55px",
    cursor: "pointer",
    fontSize: "16px",
    textAlign: "left",
    marginLeft: "38px",
    paddingLeft: "0px"
  },
  greyButton: {
    width: "100%",
    transition: "all 0.3s ease-in-out",
    backgroundColor: "inherit",
    color: colors.charcoalGrey,
    height: "55px",
    fontSize: "16px",
    textAlign: "left",
    marginLeft: "38px",
    paddingLeft: "0px"
  },
  hovered: {
    textDecoration: "underline"
  }
}

function sanitizeFilenameSegment(value) {
  return String(value || "")
    .trim()
    .replace(/[^a-z0-9]+/gi, "-")
    .replace(/^-+|-+$/g, "");
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  const { user } = state.user
  return {
    ...props,
    pyp: state.pyp,
    userModules:
      user.modules &&
      user.modules.map((item) => {
        return {
          id: item.id,
          title: item.title,
          parts_sequence:
            item.parts_sequence &&
            item.parts_sequence.split(",").map((partId) => parseInt(partId))
        }
      }),
    firstName: user && user.firstName
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(
    class PYPDownloadContainer extends Component {
      constructor(props) {
        super(props)
        this.state = {
          fetchingPYP: false,
          pypPartInitialized: false,
          PYP_modules_with_parts: null,
          downloadCourseName: null
        }
        this.retrieveDataByPartId = this.retrieveDataByPartId.bind(this)
        this.initializePYP = debounce(this.initializePYP.bind(this), 1000)
      }

      isCourseBuilderDownload() {
        const courseId = Number(this.props.pyp?.navigation?.currentCourseId)
        return courseId === ADDITIONAL_COURSE_ID
      }

      retrieveDataByPartId = async () => {
        const isCourseDownload = this.isCourseBuilderDownload()
        const courseId = Number(this.props.pyp?.navigation?.currentCourseId)

        try {
          this.setState({ fetchingPYP: true })

          const moduleData = isCourseDownload
            ? await this.props.retrieveCourseModulesWithPopulatedInputs(courseId)
            : await this.props.retrieveUserModulesWithPopulatedInputs()

          if (!moduleData || !Array.isArray(moduleData)) {
            console.error(
              "[PYPDownloadContainer] Invalid module data received:",
              moduleData
            )
            alert(
              isCourseDownload
                ? "Failed to load course data. Please try again."
                : "Failed to load PYP data. Please try again."
            )
            this.setState({
              PYP_modules_with_parts: null,
              downloadCourseName: null,
              fetchingPYP: false
            })
            return
          }

          this.setState({
            PYP_modules_with_parts: moduleData,
            downloadCourseName: isCourseDownload
              ? this.props.pyp?.navigation?.currentCourseName || null
              : null,
            fetchingPYP: false
          })
        } catch (error) {
          console.error("[PYPDownloadContainer] Error retrieving download data:", error)
          alert(
            isCourseDownload
              ? "Failed to load course data. Please try again."
              : "Failed to load PYP data. Please try again."
          )
          this.setState({
            PYP_modules_with_parts: null,
            downloadCourseName: null,
            fetchingPYP: false
          })
        }
      }

      initializePYP = () => {
        this.props.initializePYP(this.props.userModules[0].title)
      }

      buildPdfFileName() {
        const firstName = sanitizeFilenameSegment(this.props.firstName) || "User"
        const date = moment().format("MM-DD-YYYY")

        if (this.isCourseBuilderDownload() && this.state.downloadCourseName) {
          const courseSlug = sanitizeFilenameSegment(this.state.downloadCourseName)
          return `${firstName}-${courseSlug}-${date}.pdf`
        }

        return `${firstName}-Pursue-Your-Purpose-${moment().format("MM/DD/YYYY")}.pdf`
      }

      render() {
        const isCourseDownload = this.isCourseBuilderDownload()
        const prepareLabel = isCourseDownload ? "Get my PDF" : "Get my PYP PDF"

        return (
          <>
            {this.state.PYP_modules_with_parts ? (
              <PDFDownloadLink
                document={
                  <PYPDownloadPage
                    PYP_modules={this.state.PYP_modules_with_parts}
                    firstName={this.props.firstName}
                    courseName={
                      isCourseDownload && this.state.downloadCourseName
                        ? this.state.downloadCourseName
                        : undefined
                    }
                  />
                }
                fileName={this.buildPdfFileName()}
              >
                {({ blob, url, loading, error }) =>
                  loading ? (
                    <CommitButtonWithoutClickState
                      id="PYP PDF loading"
                      style={styles.greyButton}
                    >
                      Loading Document...
                    </CommitButtonWithoutClickState>
                  ) : (
                    <CommitButtonWithoutClickState
                      id="PYP PDF download"
                      style={styles.redButton}
                      hoverStyle={styles.hovered}
                    >
                      Download PDF
                    </CommitButtonWithoutClickState>
                  )
                }
              </PDFDownloadLink>
            ) : (
              <>
                {this.state.fetchingPYP ? (
                  <CommitButtonWithoutClickState
                    id="Preparing PYP Download"
                    style={styles.greyButton}
                  >
                    Preparing
                  </CommitButtonWithoutClickState>
                ) : (
                  <CommitButtonWithoutClickState
                    id="Prepare PYP Download"
                    style={styles.redButton}
                    hoverStyle={styles.hovered}
                    clickHandler={this.retrieveDataByPartId}
                  >
                    {prepareLabel}
                  </CommitButtonWithoutClickState>
                )}
              </>
            )}
          </>
        )
      }
    }
  )
)
